/* ============================================================
   FLOWZA — product card galleries.
   Was inline in fz-shop.liquid and scoped to that one section, which is
   why the other three card copies never had it. Global now: any card
   rendered by snippets/fz-card.liquid gets it, on any page.

   Same mechanism as the drop rail's cards (the [data-sg-gal] block in
   sections/fz-bestsellers.liquid): the shots are a scroll-snap track at
   every width, so a swipe scrolls it directly with the platform's own
   momentum and the arrows scroll it too. It used to be a crossfade stack
   driven by a 40px swipe threshold, which meant the two card types
   answered the same gesture differently.
   ============================================================ */
(function () {
  "use strict";

  var reduce   = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var canHover = window.matchMedia("(hover: hover)").matches;
  // RTL scrollers start at 0 and go negative.
  var dir = document.documentElement.dir === "rtl" ? -1 : 1;

  Array.prototype.forEach.call(document.querySelectorAll(".fzc [data-gal]"), function (gal) {
    var track = gal.querySelector(".fzc-track");
    if (!track) return;
    var shots = Array.prototype.slice.call(track.querySelectorAll(".fzc-img"));
    var bars = Array.prototype.slice.call(gal.querySelectorAll(".fzc-bars i"));
    if (shots.length < 2) return;

    var card = gal.closest(".fzc");
    var i = 0, timer = null, manual = false, lock = 0;

    function paint() {
      bars.forEach(function (b, k) { b.classList.toggle("on", k === i); });
    }
    function go(n, smooth) {
      i = (n + shots.length) % shots.length;          // wraps, so arrows never dead-end
      // A smooth scroll emits intermediate scroll events; without this the
      // listener below would overwrite i mid-flight and a fast second click
      // would move from the wrong index.
      clearTimeout(lock);
      lock = setTimeout(function () { lock = 0; }, 420);
      track.scrollTo({ left: dir * track.clientWidth * i, behavior: (smooth && !reduce) ? "smooth" : "auto" });
      paint();
    }
    function start(ms) {
      if (reduce) return;
      stop();
      timer = setInterval(function () { go(i + 1, true); }, ms);
      if (card) card.classList.add("is-cycling");
    }
    function stop() {
      clearInterval(timer); timer = null;
      if (card) card.classList.remove("is-cycling");
    }
    // Arrows and swipe both stop the drift -- a deliberate move should not
    // be overtaken a second later.
    function takeOver() { manual = true; stop(); }

    // Keeps the bars honest when the gesture is a swipe rather than an arrow.
    var raf;
    track.addEventListener("scroll", function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (lock) return;                              // programmatic scroll in flight
        var n = Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
        if (n !== i && n >= 0 && n < shots.length) { i = n; paint(); }
      });
    }, { passive: true });
    // A swipe is deliberate too, so it takes the card off the drift.
    track.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse") takeOver(); }, { passive: true });

    // ---- tap vs swipe -------------------------------------------------
    // .fzc-track is absolutely positioned over the WHOLE of the <a>, is a
    // horizontal scroller with -webkit-overflow-scrolling: touch, and declares
    // touch-action: pan-x. So iOS reads a tap with the slightest finger drift
    // as a pan and cancels the link -- the card looks tapped and nothing
    // happens. In the analytics one shopper tapped cards 13 times across four
    // products, never navigated once, and left ($rageclick then $dead_click);
    // across three days 39 card taps produced 19 product pages.
    // A synthetic zero-movement tap always worked, which is exactly why no
    // automated check ever caught this.
    // So decide it ourselves: a short, still touch is a tap and we navigate.
    var tx = 0, ty = 0, tt = 0;
    track.addEventListener("touchstart", function (e) {
      takeOver();
      var t = e.changedTouches[0];
      tx = t.clientX; ty = t.clientY; tt = Date.now();
    }, { passive: true });
    // Belt and braces. iOS can dispatch the click and STILL not follow the
    // link when the touch ended a scroll-snap settle. If a plain left click
    // reaches the anchor un-cancelled, follow it ourselves; modifier and
    // middle clicks are left to the browser so "open in new tab" still works.
    gal.addEventListener("click", function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.target.closest("[data-shot-nav]")) return;
      var href = gal.getAttribute("href");
      if (!href) return;
      e.preventDefault();
      window.location.href = href;
    });
    track.addEventListener("touchend", function (e) {
      var t = e.changedTouches[0];
      if (Date.now() - tt > 500) return;                              // long press
      if (Math.abs(t.clientX - tx) > 10 || Math.abs(t.clientY - ty) > 10) return;  // swipe
      // No "was the track moving" guard any more. A scroll-snap track twitches
      // a pixel or two under a perfectly still finger, and that guard threw
      // away the tap in exactly the case it existed for. The finger is the
      // intent signal, and the 10px test above already has it.
      var href = gal.getAttribute("href");
      // Same URL the browser would have gone to, so if it does fire the click
      // after all this is a no-op rather than a double navigation.
      if (href) window.location.href = href;
    }, { passive: true });

    gal.querySelectorAll("[data-shot-nav]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();       // don't follow the card link
        takeOver();
        go(i + (btn.getAttribute("data-shot-nav") === "next" ? 1 : -1), true);
      });
    });

    // Auto-advance is a POINTER-DEVICE affordance, the same rule the drop rail
    // already follows ("on touch, hover would fire on tap and fight the swipe"
    // -- sections/fz-bestsellers.liquid). This copy dropped that guard when it
    // was generalised, so on a phone mouseenter fired on tap and every card on
    // screen scrolled its own images every 3.2s, moving the target under the
    // thumb mid-tap.
    if (!canHover) return;
    gal.addEventListener("mouseenter", function () { if (!manual) start(900); });
    gal.addEventListener("mouseleave", function () { if (!manual) start(3200); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !manual) start(3200);
          else if (!e.isIntersecting) stop();
        });
      }, { threshold: 0.35 }).observe(gal);
    } else { start(3200); }
  });
})();
